export class FunctionalAnalysesDataErrorResponse {
  srcContribution: any;
  destContribution: any;
}
